import { axiosInstance } from "../../utils/axios";
import { TgkAmount, TgkTable } from "../models";
import { TgkDimensionAttribute } from "../models/tgk-dimension-attribute";
import { TgkText } from "../models/tgk-text";
import { ComponentReference } from "../models/component-reference";

export async function fetchDocumentComponents(documentId: string): Promise<ComponentReference[]> {
  const params = { documentId };
  let response = await axiosInstance.get(`/components`, { params });
  return response.data;
}

export async function fetchTableComponent(documentId: string, contentControlId: string): Promise<TgkTable> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/table`, { params });
  return response.data;
}

export async function fetchLegacyTableComponent(componentLogicId: string): Promise<TgkTable> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/table`, { params });
  return response.data;
}

export async function fetchChartComponent(documentId: string, contentControlId: string): Promise<TgkTable> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/chart`, { params });
  return response.data;
}

export async function fetchLegacyChartComponent(componentLogicId: string): Promise<TgkTable> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/chart`, { params });
  return response.data;
}

export async function fetchAmountComponent(documentId: string, contentControlId: string): Promise<TgkAmount> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/amount`, { params });
  return response.data;
}

export async function fetchLegacyAmountComponent(componentLogicId: string): Promise<TgkAmount> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/amount`, { params });
  if (response.data == null || response.data === "") {
    return null;
  }
  return response.data;
}

export async function fetchAmountAihComponent(documentId: string, contentControlId: string): Promise<TgkAmount> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/amountAih`, { params });
  return response.data;
}

export async function fetchLegacyAmountAihComponent(componentLogicId: string): Promise<TgkAmount> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/amountAih`, { params });
  return response.data;
}

export async function fetchDimensionAttributeComponent(
  documentId: string,
  contentControlId: string
): Promise<TgkDimensionAttribute> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/dimensionAttribute`, { params });
  return response.data;
}

export async function fetchLegacyDimensionAttributeComponent(componentLogicId: string): Promise<TgkDimensionAttribute> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/dimensionAttribute`, { params });
  return response.data;
}

export async function fetchTgkTextComponent(documentId: string, contentControlId: string): Promise<TgkText> {
  const params = { documentId, contentControlId };
  let response = await axiosInstance.get(`/component/tgkText`, { params });
  return response.data;
}

export async function fetchLegacyTgkTextComponent(componentLogicId: string): Promise<TgkText> {
  const params = { componentLogicId };
  let response = await axiosInstance.get(`/component/legacy/tgkText`, { params });
  return response.data;
}
